import React, { useEffect } from "react";

// Libraries
import { Col, Container, Row } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import { Parallax } from "react-scroll-parallax";
import { m } from "framer-motion";

// Component
import RDPHeader from "../Components/Header/RDPHeader";
import RDPFooter from "../Components/Footers/RDPFooter";
import Buttons from '../Components/Button/Buttons'
import IconWithText from '../Components/IconWithText/IconWithText'
import OptimizedImage from "../Components/OptimizedImage";
import { fadeIn } from "../Functions/GlobalAnimations";
import InViewPort from "../Components/InViewPort";

// Data
import { InteractiveBannersData03 } from "../Components/InteractiveBanners/InteractiveBannersData";

// Valeurs clés (3 icônes) - BASÉES SUR LE VRAI SITE RDP GLASS
const IconWithTextData = [
  {
    icon: "line-icon-Handshake text-glass-accent text-[40px]",
    title: "Du relationnel !",
    content: "Dans ce monde de communication moderne, beaucoup d'affaires se traitent par emails ou par téléphone. RDP privilégie de son côté l'opportunité de rencontrer ses clients face à face.",
  },
  {
    icon: "line-icon-Ear text-glass-accent text-[40px]",
    title: "De l'écoute !",
    content: "Notre façon de travailler nous met directement à l'écoute de vos besoins, ce qui nous permet de répondre au mieux à vos attentes. Chaque offre est personnalisée car chacun de nos clients est unique.",
  },
  {
    icon: "line-icon-Gears text-glass-accent text-[40px]",
    title: "Du service !",
    content: "À votre demande, nous produisons vos plans verriers, ainsi que les maquettes 3D de vos bouteilles et bocaux.",
  },
];

const HomePage = (props) => {
  const swiperRef = React.useRef(null);

  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={props.style}>
      {/* Header Start*/}
      <RDPHeader {...props} />
      {/* Header End*/}

      {/* Hero Section - IMPACTANT */}
      <m.section className="relative full-screen overflow-hidden landscape:md:h-[600px] bg-white pt-[100px] md:pt-[80px]" {...fadeIn}>
        <Container className="h-full relative z-[1] px-4">
          <Row className="h-full items-center justify-center">
            <Col xs={12} sm={10} md={10} lg={9} xl={8} className="text-center relative">
              <m.div
                className="mb-12"
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: 0.2, duration: 0.6 }}
              >
                <OptimizedImage
                  avifSrc="/logo-rdp-hero.avif"
                  webpSrc="/logo-rdp-hero.webp"
                  fallbackSrc={require("../Assets/img/products/Logo-RDP-optimized.png")}
                  alt="RDP Glass - Recherche & Développement en Packaging"
                  className="mx-auto max-w-full w-auto h-auto drop-shadow-lg"
                  style={{ maxWidth: 'min(640px, 80vw)' }}
                  width={640}
                  height={263}
                  loading="eager"
                  fetchpriority="high"
                />
              </m.div>
              <m.h1
                className="font-serif font-bold text-glass-darkest text-[28px] leading-tight mb-[20px] sm:text-[32px] md:text-[40px] lg:text-[50px] xl:text-[70px] xl:leading-[80px] xl:mb-[30px]"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.4 }}
              >
                World Class Packaging
              </m.h1>
              <m.p
                className="text-glass-dark text-xlg font-serif mb-[45px] w-[80%] mx-auto lg:w-[90%] md:text-lg"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.6 }}
              >
                Réseau professionnel de distribution d'emballages en verre.<br />
                Un accès privilégié à de nombreux verriers Européens et extra-Européens absents du marché Français.
              </m.p>
              <m.div
                className="flex justify-center gap-4 sm:flex-col sm:items-center"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.8 }}
              >
                <Buttons
                  to="/produits"
                  className="font-medium font-serif uppercase glass-btn-medium text-glass-darkest hover:text-glass-accent"
                  size="lg"
                  title="Découvrir nos produits"
                />
                <Buttons
                  to="/contact"
                  className="font-medium font-serif uppercase glass-btn-medium text-glass-darkest hover:text-glass-accent"
                  size="lg"
                  title="Demander un devis"
                />
              </m.div>
            </Col>
          </Row>
        </Container>
      </m.section>
      {/* Hero End */}

      <InViewPort>
        {/* Section expérience */}
        <section className="py-[160px] lg:py-[120px] md:py-[95px] sm:py-[80px] xs:py-[50px] glass-separator-dots bg-white">
          <Container>
            <Row className="items-center justify-center md:items-start sm:text-center">
              <Col lg={4} md={6} className="md:mb-[50px]">
                <m.div className="inline-block text-center w-[300px] py-14 px-[15px] relative" {...{ ...fadeIn, transition: { delay: 0.2 } }}>
                  <div className="border-r-0 border-solid border-[10px] border-glass-darkest h-full w-[67px] block absolute bottom-0 left-0"></div>
                  <div className="text-[80px] leading-[72px] mb-0 mr-[15px] font-semibold tracking-[-5px] text-glass-accent font-serif inline-block align-middle">
                    35+
                  </div>
                  <div className="w-[40%] leading-[20px] font-medium text-glass-dark text-xmd font-serif text-left relative inline-block align-middle lg:w-[50%] sm:w-[35%]">
                    Années d'expertise
                  </div>
                  <div className="border-l-0 border-solid border-[10px] border-glass-darkest h-full w-[67px] block absolute bottom-0 right-0"></div>
                </m.div>
              </Col>
              <Col lg={3} md={4}>
                <m.div {...{ ...fadeIn, transition: { delay: 0.4 } }}>
                  <span className="mb-[20px] text-md font-serif uppercase block text-glass-accent">
                    Depuis 2008
                  </span>
                  <span className="w-[85%] leading-[34px] font-medium text-glass-darkest text-xlg font-serif block lg:leading-0 lg:text-lg sm:w-full sm:mb-[15px]">
                    Distributeur d'emballages en verre basé en France
                  </span>
                </m.div>
              </Col>
              <Col lg={5} md={10}>
                <m.div {...{ ...fadeIn, transition: { delay: 0.6 } }}>
                  <p className="w-[84%] mb-[25px] block lg:w-full">
                    RDP Glass distribue des solutions d'emballage en verre innovantes et écologiques depuis plus de 15 ans. Bouteilles de vin, bière, spiritueux, bocaux, soft drinks... Nous accompagnons les professionnels de l'agroalimentaire avec notre réseau de fournisseurs.
                  </p>
                  <Buttons
                    to="/a-propos"
                    className="font-medium font-serif uppercase glass-btn-medium text-glass-darkest hover:text-glass-accent md:text-md md:mb-[15px]"
                    title="En savoir plus"
                    size="xl"
                  />
                </m.div>
              </Col>
            </Row>
          </Container>
        </section>
        {/* Section End */}

        {/* Nos Marchés - Carousel */}
        <section className="py-[130px] lg:py-[90px] md:py-[75px] sm:py-[50px] bg-white glass-separator-dots overflow-visible">
          <Container>
            {/* Titre et description en dehors de la glass-card */}
            <Row className="justify-center mb-20">
              <Col lg={8} md={10} className="text-center">
                <m.h2
                  className="heading-3 font-serif font-semibold text-glass-darkest mb-[20px]"
                  {...fadeIn}
                >
                  Nos marchés
                </m.h2>
                <m.p
                  className="text-glass-dark text-lg mb-[15px]"
                  {...{ ...fadeIn, transition: { delay: 0.2 } }}
                >
                  Une présence sur les marchés Français - Intra et Dom-Tom - et Belge couvrant l'ensemble de vos besoins.
                </m.p>
                <m.p
                  className="text-glass-light text-md"
                  {...{ ...fadeIn, transition: { delay: 0.3 } }}
                >
                  Pour les modèles standards comme pour les modèles personnalisés.<br />
                  Conception 3D et maquettes sur demande.
                </m.p>
              </Col>
            </Row>

            {/* Container glassmorphism pour le carousel */}
            <div className="glass-container-prominent p-12 lg:p-10 md:p-8 sm:p-6">
              <Row>
              <Col className="relative">
                {/* Navigation buttons */}
                <div
                  onClick={() => swiperRef.current.swiper.slidePrev()}
                  className="btn-slider-prev bg-glass-dark z-[11] text-white w-[50px] h-[50px] left-[-100px] lg:left-[-90px] md:left-[-75px] sm:left-[10px] transition-default leading-[40px] m-0 right-auto absolute top-[50%] -translate-y-1/2 flex items-center justify-center hover:bg-glass-accent cursor-pointer rounded-full"
                >
                  <button className="text-xmd" aria-label="prev btn">
                    <i className="feather-arrow-left"></i>
                  </button>
                </div>

                <div
                  onClick={() => swiperRef.current.swiper.slideNext()}
                  className="btn-slider-next bg-glass-dark z-[11] text-white w-[50px] h-[50px] right-[-100px] lg:right-[-90px] md:right-[-75px] sm:right-[10px] transition-default leading-[40px] m-0 left-auto absolute top-[50%] -translate-y-1/2 flex items-center justify-center hover:bg-glass-accent cursor-pointer rounded-full"
                >
                  <button className="text-xmd" aria-label="next btn">
                    <i className="feather-arrow-right"></i>
                  </button>
                </div>

                <Swiper
                  ref={swiperRef}
                  className="InteractiveBanners03-carousel"
                  modules={[Autoplay, Pagination, Navigation]}
                  spaceBetween={30}
                  slidesPerView={1}
                  loop={true}
                  autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                  }}
                  pagination={{
                    clickable: true,
                    dynamicBullets: false,
                  }}
                  breakpoints={{
                    576: {
                      slidesPerView: 1.2,
                    },
                    768: {
                      slidesPerView: 2,
                    },
                    992: {
                      slidesPerView: 3,
                    },
                    1200: {
                      slidesPerView: 4,
                    },
                  }}
                >
                  {InteractiveBannersData03.map((item, i) => (
                    <SwiperSlide key={i}>
                      <m.div
                        className="interactive-banners-style-03 relative overflow-hidden cursor-pointer group h-[500px] md:h-[450px] sm:h-[400px] rounded-lg"
                        {...{ ...fadeIn, transition: { delay: i * 0.15 } }}
                      >
                        <a href={item.imgLink} className="block h-full">
                          <img src={item.img} alt={item.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
                          <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-transparent via-transparent to-glass-darkest opacity-80 group-hover:opacity-90 transition-opacity"></div>
                          <div className="absolute bottom-0 left-0 w-full p-[40px] text-white">
                            <span className="text-md font-serif uppercase block mb-[10px] opacity-70">
                              {item.subtitle}
                            </span>
                            <div className="font-serif font-semibold text-[28px] mb-[20px]">
                              {item.title}
                            </div>
                            <span className="text-white font-serif uppercase text-sm group-hover:text-glass-accentLight transition-colors inline-flex items-center gap-2">
                              {item.btnTitle}
                              <i className={item.icon}></i>
                            </span>
                          </div>
                        </a>
                      </m.div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </Col>
            </Row>
            </div>
            {/* Fin container glassmorphism */}
          </Container>
        </section>
        {/* Marchés End */}

        {/* Valeurs - 3 icônes */}
        <section className="bg-white glass-separator-dots py-[130px] lg:py-[90px] md:py-[75px] sm:py-[50px]">
          <Container>
            <Row className="justify-center mb-20">
              <Col lg={7} md={9} className="text-center">
                <m.h2
                  className="heading-3 font-serif font-semibold text-glass-darkest mb-[15px]"
                  {...fadeIn}
                >
                  Nos valeurs
                </m.h2>
                <m.p
                  className="text-glass-dark text-lg"
                  {...{ ...fadeIn, transition: { delay: 0.2 } }}
                >
                  Au service de votre projet depuis plus de 15 ans
                </m.p>
              </Col>
            </Row>
            <IconWithText
              grid="row-cols-1 row-cols-lg-3 row-cols-sm-1 gap-y-[50px] justify-center"
              theme="icon-with-text-01"
              data={IconWithTextData}
              animation={fadeIn}
              animationDelay={0.2}
            />
          </Container>
        </section>
        {/* Valeurs End */}

        {/* Pourquoi le verre - Section éco */}
        <m.section
          className="py-[130px] lg:py-[90px] md:py-[75px] sm:py-[50px] relative overflow-hidden glass-separator-dots bg-white"
          {...fadeIn}
        >
          <Container>
            <Row className="items-center">
              <Col lg={6} md={12} className="md:mb-[50px]">
                <div className="relative">
                  <Parallax className="lg-no-parallax" speed={5}>
                    <OptimizedImage
                      avifSrc={require("../Assets/img/products/750ml-Kilner-Jar-optimized.avif")}
                      webpSrc={require("../Assets/img/products/750ml-Kilner-Jar-optimized.webp")}
                      fallbackSrc={require("../Assets/img/products/750ml-Kilner-Jar-optimized.jpg")}
                      alt="Emballage verre recyclable"
                      className="w-full rounded-lg shadow-lg"
                      width={1200}
                      height={1600}
                    />
                  </Parallax>
                  <div className="absolute -bottom-8 -right-8 bg-glass-accent text-white p-8 rounded-lg shadow-xl max-w-[280px] sm:relative sm:bottom-0 sm:right-0 sm:mt-8">
                    <div className="text-[48px] font-bold font-serif mb-2">100%</div>
                    <div className="text-md font-serif uppercase">Recyclable infiniment</div>
                  </div>
                </div>
              </Col>
              <Col lg={6} md={12}>
                <m.div {...{ ...fadeIn, transition: { delay: 0.2 } }}>
                  <span className="text-glass-accent font-serif font-medium text-md uppercase block mb-[15px] tracking-[1px]">
                    Pourquoi le verre ?
                  </span>
                  <h2 className="heading-3 font-serif font-semibold text-glass-darkest mb-[30px]">
                    Un matériau naturellement écologique
                  </h2>
                  <p className="text-glass-dark text-lg mb-[25px] leading-[32px]">
                    Le verre est le seul matériau d'emballage 100% recyclable, infiniment et sans perte de qualité.
                    Il préserve parfaitement les qualités organoleptiques de vos produits tout en respectant l'environnement.
                  </p>
                  <ul className="list-style-02 mb-[35px]">
                    <li className="mb-[15px] flex items-start">
                      <i className="feather-check text-glass-accent text-[20px] mr-[15px] mt-[5px]"></i>
                      <span className="text-glass-dark">Matière première naturelle et inerte</span>
                    </li>
                    <li className="mb-[15px] flex items-start">
                      <i className="feather-check text-glass-accent text-[20px] mr-[15px] mt-[5px]"></i>
                      <span className="text-glass-dark">Recyclage infini sans altération</span>
                    </li>
                    <li className="mb-[15px] flex items-start">
                      <i className="feather-check text-glass-accent text-[20px] mr-[15px] mt-[5px]"></i>
                      <span className="text-glass-dark">Protection optimale du produit</span>
                    </li>
                    <li className="flex items-start">
                      <i className="feather-check text-glass-accent text-[20px] mr-[15px] mt-[5px]"></i>
                      <span className="text-glass-dark">Image premium et valorisante</span>
                    </li>
                  </ul>
                  <Buttons
                    to="/a-propos"
                    className="font-medium font-serif uppercase glass-btn-medium text-glass-darkest hover:text-glass-accent"
                    title="En savoir plus sur RDP Glass"
                    size="lg"
                  />
                </m.div>
              </Col>
            </Row>
          </Container>
        </m.section>
        {/* Pourquoi verre End */}

        {/* Footer Start */}
        <RDPFooter />
        {/* Footer End */}
      </InViewPort>
    </div>
  );
};

export default HomePage;
